'use client';

import { useEffect, useRef, useState } from 'react';

import { logger } from '@/utils';

type UseLottieDataReturn = object | null;

const cache = new Map<string, object>();

export const useLottieData = (src: string): UseLottieDataReturn => {
  const [data, setData] = useState<object | null>(() => cache.get(src) ?? null);
  const abortRef = useRef<AbortController | null>(null);

  useEffect(() => {
    if (cache.has(src)) {
      return;
    }

    const controller = new AbortController();
    abortRef.current = controller;

    fetch(src, { signal: controller.signal })
      .then((res) => res.json())
      .then((json: object) => {
        cache.set(src, json);
        setData(json);
      })
      .catch((err) => {
        if (err.name !== 'AbortError') logger.error(err);
      });

    return () => {
      controller.abort();
    };
  }, [src]);

  return data;
};
